import { c as _c } from "react/compiler-runtime";
import { LocaleEnum, Tooltip, localeLabels, localeNames } from '@systemeio/ui';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ChevronDownIcon } from '@systemeio/ui/icons';
export interface LanguageSwitcherProps {
  selectedLanguage: LocaleEnum;
  changeLanguage: (locale: LocaleEnum) => void;
  listOfLanguages?: LocaleEnum[];
  isFetching?: boolean;
  buttonClassName?: string;
  menuClassName?: string;
  labelClassName?: string;
  wrapperClassName?: string;
}
export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = t0 => {
  const $ = _c(33);
  const {
    selectedLanguage,
    changeLanguage,
    listOfLanguages: t1,
    isFetching,
    buttonClassName,
    labelClassName,
    wrapperClassName
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? Object.values(LocaleEnum) : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const listOfLanguages = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: -5
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isFetching && "pointer-events-none";
  let t5;
  if ($[3] !== t4) {
    t5 = twMerge("customScroll bg-background-secondary z-50 max-h-[400px] overflow-hidden overflow-y-auto rounded-lg shadow-lg", t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== changeLanguage || $[6] !== listOfLanguages || $[7] !== selectedLanguage) {
    let t7;
    if ($[9] !== changeLanguage || $[10] !== selectedLanguage) {
      t7 = language => <li key={language}><button disabled={language === selectedLanguage} className={`hover:text-brand-primary focus-visible:text-brand-primary main-transition-colors text-start w-full px-7 py-1 focus:outline-hidden ${language === selectedLanguage ? "text-brand-primary" : "text-text-tertiary"}`} data-test={`language-switcher-option-button-${language}`}><p onClick={() => changeLanguage(language)}>{localeNames[language]}</p></button></li>;
      $[9] = changeLanguage;
      $[10] = selectedLanguage;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    t6 = listOfLanguages.map(t7);
    $[5] = changeLanguage;
    $[6] = listOfLanguages;
    $[7] = selectedLanguage;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <ul className="text-text-tertiary flex flex-col whitespace-nowrap py-4 text-sm">{t6}</ul>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== buttonClassName) {
    t9 = twMerge("flex items-center gap-2 text-sm font-normal", buttonClassName);
    $[17] = buttonClassName;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== labelClassName) {
    t10 = twMerge("text-start flex-1 capitalize", labelClassName);
    $[19] = labelClassName;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = selectedLanguage && localeLabels[selectedLanguage];
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ChevronDownIcon />;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== isFetching || $[26] !== t12 || $[27] !== t9) {
    t14 = <button disabled={isFetching} className={t9} data-test="language-switcher-button">{t12}{t13}</button>;
    $[25] = isFetching;
    $[26] = t12;
    $[27] = t9;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14 || $[30] !== t8 || $[31] !== wrapperClassName) {
    t15 = <Tooltip anchor={t3} wrapperClassName={wrapperClassName} stayOnHover={true} className="h-full" popoverClassName="p-0 shadow-lg rounded-lg" label={t8}>{t14}</Tooltip>;
    $[29] = t14;
    $[30] = t8;
    $[31] = wrapperClassName;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
};